import { render } from "./SystemLogsHistory.vue?vue&type=template&id=1cb773ec&scoped=true"
import script from "./SystemLogsHistory.vue?vue&type=script&lang=js"
export * from "./SystemLogsHistory.vue?vue&type=script&lang=js"

import "./SystemLogsHistory.vue?vue&type=style&index=0&id=1cb773ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb773ec"]])

export default __exports__